import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Cart from "../../../../CM/cm_open_loop/components/fusionDataListing/cart";
import { v4 as uuidv4 } from "uuid";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { cartCountUpdate,addGroupToCart,
        addVariationToGroup,
        cartCount,
        selectedScenarioUuidList,
        selectedScenarioNameList, } from "../../../../../actions/CM/cm_open_loop/fusionDataCarMakerCollection/addToCartFusionDataCollectionAction";
function cartComponent(props) {
    const [scenarioPopup, setScenarioPopup] = useState(false);
    const [scenarioGroupNameFlag, setScenarioGroupNameFlag] = useState(false);
    const [scenarioGroupNumber, setScenarioGroupNumber] = useState(0);
    const [scenarioGroupNumberFlag, setScenarioGroupNumberFlag] = useState(false);
    const [alertCheck,setAlertCheck]=useState(false)
    function openPopupModal() {
        setScenarioPopup(true);
    }
    function closePopupModal() {
        setScenarioPopup(false);
    }
    function onScenarioGroupNameChange(event) {
        if (event.target.value === "") {
            setScenarioGroupNameFlag(false);
        } else {
            setScenarioGroupNameFlag(true);
            let obj = {
                group: event.target.value,
            };
            props.addGroupToCart(obj);
        }
    }

    function onScenarioGroupNumberChange(event) {
        setScenarioGroupNumber(event.target.value);
        let text;
        if (
            isNaN(event.target.value) ||
            event.target.value < 1 ||
            event.target.value > props.count
        ) {
            text = "Input invalid";
            setScenarioGroupNumberFlag(false);
        } else {
            text = "Input OK";
            setScenarioGroupNumber(event.target.value);
            if (isNaN(event.target.value)) {
                setScenarioGroupNumberFlag(false);
            } else {
                setScenarioGroupNumberFlag(true);
            }
        }
        document.getElementById("demo").innerHTML = text;
    }

    function onScenarioGroupNumberBulkVariationChange(event) {
        setScenarioGroupNumber(event.target.value);
        let text;
        if (
            isNaN(event.target.value) ||
            event.target.value < 1 ||
            event.target.value > props.bulkVariationCartCount
        ) {
            text = "Input invalid";
            setScenarioGroupNumberFlag(false);
        } else {
            text = "Input OK";
            setScenarioGroupNumber(event.target.value);
            if (isNaN(event.target.value)) {
                setScenarioGroupNumberFlag(false);
            } else {
                setScenarioGroupNumberFlag(true);
            }
        }
        document.getElementById("demo").innerHTML = text;
    }

    function creationStatus() {
        if (Object.keys(props.groupCreationStatus).length > 0) {
            let resetObject = {
                count: 0,
                items: [],
            };
            props.cartCountUpdate(resetObject);
            props.selectedScenarioUuidList([]);
            props.selectedScenarioNameList([]);
            props.cartCount(0);
            alert(props.groupCreationStatus.status_message);
            setAlertCheck(false)

        }

    }

    function submitScenarioGroup() {
        if (
            scenarioGroupNameFlag === false ||
            scenarioGroupNumberFlag === false ||
            (scenarioGroupNameFlag === false && scenarioGroupNumberFlag === false)
        ) {
            alert("Please fill required fields with correct data");
        } else {
            let scenarioNameArray;
            let totalSelectedVariationCount;
            if (props.items.length === 0) {
                scenarioNameArray = props.scenarioObjectListData;
                totalSelectedVariationCount = props.bulkVariationCartCount;
            } else {
                scenarioNameArray = props.items;
                totalSelectedVariationCount = props.count;
            }
            const url = window.location.origin.concat(
                "/cm_base_bulk_grouping_of_scenarios_collection"
            );
            const dataForAddition = {
                group_name: props.group,
                list_of_scns: scenarioNameArray,
                total_scenarios: totalSelectedVariationCount,
                group_number: scenarioGroupNumber,
                scenario_group_uuid: uuidv4(),
            };
            console.log("dataForAddition", dataForAddition);
            props.addVariationToGroup(url, dataForAddition);
            alert("Scenario Grouping will be starting");
            closePopupModal();
            setAlertCheck(true)

        }
    }

    useEffect(() => { 
       alertCheck && creationStatus();
    }, [props.groupCreationStatus]);
    

    return (
        <div>
            <div>
                <button
                    onClick={openPopupModal}
                    style={{
                        backgroundColor: "Transparent",
                        outline: "None",
                        border: "None",
                        float: "right",
                    }}
                >
                    <Cart />
                </button>
            </div>
            {scenarioPopup ? (
                <Modal isOpen={scenarioPopup}>
                    <ModalHeader>Items Added</ModalHeader>
                    <ModalBody>
                        <div className="card">
                            <div className="card-body">
                                {props.count === 0 &&
                                Object.keys(props.scenarioObjectListData).length === 0 ? (
                                    <p>Please Select Scenarios</p>
                                ) : props.count !== 0 &&
                                  Object.keys(props.scenarioObjectListData).length === 0 ? (
                                    <div className="form-group">
                                        <h5 style={{ color: "#008000" }}>
                                            Selected scenario variations : {props.count}{" "}
                                        </h5>
                                        Scenario Group Name{" "}
                                        <input
                                            type="text"
                                            className="form-control"
                                            list="data"
                                            onChange={onScenarioGroupNameChange}
                                            required
                                        />
                                        <div>
                                            Expected Group Number
                                            <input
                                                type="number"
                                                className="form-control"
                                                onChange={onScenarioGroupNumberChange}
                                                required
                                            />
                                            <p style={{ color: "#FF0000" }} id="demo"></p>
                                        </div>
                                    </div>
                                ) : props.count === 0 &&
                                  Object.keys(props.scenarioObjectListData).length !== 0 ? (
                                    <div className="form-group">
                                        <h5 style={{ color: "#008000" }}>
                                            Total scenario variations selected :{" "}
                                            {props.bulkVariationCartCount}{" "}
                                        </h5>
                                        Scenario Group Name{" "}
                                        <input
                                            type="text"
                                            className="form-control"
                                            list="data"
                                            onChange={onScenarioGroupNameChange}
                                            required
                                        />
                                        <div>
                                            Expected Group Number
                                            <input
                                                type="number"
                                                className="form-control"
                                                onChange={onScenarioGroupNumberBulkVariationChange}
                                                required
                                            />
                                            <p style={{ color: "#FF0000" }} id="demo"></p>
                                        </div>
                                    </div>
                                ) : undefined}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {props.count === 0 || props.error ? undefined : (
                            <Button
                                className="btn"
                                style={{ backgroundColor: "#757AF7" }}
                                onClick={submitScenarioGroup}
                            >
                                Add To Scenario Group
                            </Button>
                        )}
                        {Object.keys(props.scenarioObjectListData).length === 0 ? undefined : (
                            <Button
                                className="btn"
                                style={{ backgroundColor: "#757AF7" }}
                                onClick={submitScenarioGroup}
                            >
                                Add To Scenario Group
                            </Button>
                        )}
                        <Button
                            className="btn"
                            style={{ backgroundColor: "#757AF7" }}
                            onClick={closePopupModal}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
        </div>
    );
}

const mapStateToProps = (state) => ({
    count: state.addToCartScenarioCollectionData.count,
    items: state.addToCartScenarioCollectionData.items,
    group: state.addToCartScenarioCollectionData.group,
    groupCreationStatus: state.addVariationToGroupStatus.groupCreationStatus,
    loading: state.addVariationToGroupStatus.loading,
    scenarioObjectListData: state.addBulkScenariosToListStatus.selectedScenarioObjectList,
    bulkVariationCartCount: state.bulkVariationCartCountReducerStatus.totalBulkVariationSelected,
});

const mapDispatchToProps = (dispatch) => ({
    cartCountUpdate: (resetObject) => dispatch(cartCountUpdate(resetObject)),
    addGroupToCart: (groupName) => dispatch(addGroupToCart(groupName)),
    addVariationToGroup: (url, dataForAddition) =>
    dispatch(addVariationToGroup(url, dataForAddition)),
    cartCount: (variationCount) => dispatch(cartCount(variationCount)),
    selectedScenarioUuidList: (variationUuid) => dispatch(selectedScenarioUuidList(variationUuid)),
    selectedScenarioNameList: (variationUuid) => dispatch(selectedScenarioNameList(variationUuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(cartComponent);
